export default __webpack_public_path__ + "static/media/img_7.3b36362b.jpg";